import { render, staticRenderFns } from "./date-widget.vue?vue&type=template&id=24835cac&scoped=true&"
import script from "./date-widget.vue?vue&type=script&lang=js&"
export * from "./date-widget.vue?vue&type=script&lang=js&"
import style0 from "./date-widget.vue?vue&type=style&index=0&id=24835cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24835cac",
  null
  
)

export default component.exports